export default "__VITE_ASSET__98e74442__"